import { useCallback, useState } from 'react'
import { createBooking } from '../services/cinch-servicing'
import { MaintenanceContext } from '../context/maintenance-context'
import { isMobileApp } from '../utils'

export const useCreateBooking = () => {
  const [loading, setLoading] = useState(false)
  const [bookingCreated, setBookingCreated] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const bookAppointment = useCallback(
    async (
      {
        customerTitle,
        customerFirstName,
        customerSurname,
        customerEmail,
        customerPhone,
        customerAddress,
        dealerId,
        store,
        serviceOptionsSelectedNames,
        appointmentType,
        bookingDate,
        bookingTime,
        vrm,
        vehicleVin,
        mileage,
        emailPermissions,
        appointmentTypeId,
        notes,
      }: MaintenanceContext,
      campaignId?: string,
    ) => {
      if (
        !customerTitle ||
        !customerFirstName ||
        !customerSurname ||
        !customerEmail ||
        !customerPhone ||
        !customerAddress ||
        !serviceOptionsSelectedNames ||
        !appointmentType ||
        !vrm ||
        !vehicleVin ||
        !dealerId ||
        !appointmentTypeId ||
        !bookingDate ||
        !bookingTime
      ) {
        setLoading(false)
        setError(new Error('Missing Booking Value'))
        return
      }

      setLoading(true)
      setError(null)

      try {
        const isApp = isMobileApp()

        const success = await createBooking({
          customer: {
            title: customerTitle,
            firstName: customerFirstName,
            lastName: customerSurname,
            email: customerEmail,
            mobile: customerPhone,
            address: {
              street: `${customerAddress.addressLine1}${
                customerAddress.addressLine2
                  ? ` ${customerAddress.addressLine2}`
                  : ''
              }`,
              city: customerAddress.postTown || undefined,
              county: customerAddress.county || undefined,
              postCode: customerAddress.postcode,
            },
          },
          bookingDetails: {
            storeId: dealerId,
            storeName: store,
            bookingDate,
            bookingTime,
            serviceOptions: serviceOptionsSelectedNames
              .split(', ')
              .map((so) => ({ serviceType: so, description: so })),
            appointmentTypeId,
            ...(notes ? { notes } : {}),
          },
          vehicle: {
            mileage: mileage ?? 0,
            vrm,
            vin: vehicleVin,
          },
          ...(emailPermissions !== undefined
            ? { marketingPreferences: { email: emailPermissions } }
            : {}),
          campaignId,
          deviceContext: isApp ? 'app' : 'web',
        })
        if (success) {
          setBookingCreated(true)
          setError(null)
        } else {
          setError(new Error('Booking request failed to send'))
        }
      } catch (error) {
        setError(error as Error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  return {
    bookAppointment,
    loading,
    bookingCreated,
    error,
  }
}
